import { render, staticRenderFns } from "./projectItem.vue?vue&type=template&id=9a68b394&scoped=true&"
import script from "./projectItem.vue?vue&type=script&lang=js&"
export * from "./projectItem.vue?vue&type=script&lang=js&"
import style0 from "./projectItem.vue?vue&type=style&index=0&id=9a68b394&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a68b394",
  null
  
)

export default component.exports